import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class RecallReportService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
	}

	public expiryReport(obj) {
  		
		return this.http.post(environment.apiurl + "/Reports/recall?access_token=" + this.globalCfgService.getAccessToken(), obj);
	}
    
    getContributionReport(companyId, fromDtm, toDtm, presentation, selectedMentorId) {
        var payload = {
            companyId: companyId,
            fromDtm: fromDtm,
            toDtm: toDtm,
            presentation: presentation
        };

        if (selectedMentorId && selectedMentorId != 'all') {
            payload['mentorUserId'] = selectedMentorId*1
        }
        return this.http.post(environment.apiurl + '/Dashboards/contributionReport?access_token=' + this.globalCfgService.getAccessToken(), payload);
    }

}
